import React, { Component } from "react";
import { Messages } from "primereact/messages";
import { Growl } from "primereact/growl";
import axios from "axios";
import { AutoComplete } from "primereact/autocomplete";
import { InputText } from "primereact/inputtext";
import "react-datepicker/dist/react-datepicker.css";
import "react-inputs-validation/lib/react-inputs-validation.min.css";
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import addMonths from "date-fns/addMonths";
import subMonths from "date-fns/subMonths";
import * as appConst from "../../Common/constants";

class Inbound extends Component {
  constructor(props) {
    super(props);

    this.state = {
      spinnerClass: "collapse",
      dataClass: "",
      nameSuggestions: null,
      nameList: [],
      medList: [],
      mainStock: 0,
      qty: 0,
      mno: "",
      name: ""
    };

  }

  componentDidMount() {
    this.LoadNames();
  }

  LoadNames() {
    let _nameList = [];
    axios
      .get(
        (process.env.NODE_ENV !== "development"
          ? appConst.API_URL_PROD
          : appConst.API_URL_DEV) +
        "/medicine/getNames"
      )
      .then(response => {
        this.setState({ medList: response.data });
        let nameData = response.data;
        nameData.forEach(function (item) {
          _nameList.push(item.name);
        });
        this.setState({ nameList: _nameList });
      })
      .catch(function (error) {
        console.log(error);
      });
  }

  suggestName(event) {
    let results = this.state.nameList.filter(t => {
      return t.toLowerCase().includes(event.query.toLowerCase());
    });
    this.setState({ nameSuggestions: results });
  }

  render() {
    return (
      <div>
        <div>
          <h5 align="center">Medicine Inbound</h5>
        </div>
        <div className="container-fluid">
          <div className="row p-1 border">
            <div className="col col-md-2">Medicine</div>
            <div className="col col-md-4">
              <AutoComplete
                value={this.state.name}
                onChange={this.onNameChange}
                suggestions={this.state.nameSuggestions}
                completeMethod={this.suggestName.bind(this)}
                onSelect={this.onNameSelect}
                size={38}
                className="p-error"
              />
              <div className="text-danger font-weight-bold">
                Stock : {this.state.mainStock}
              </div>
            </div>
          </div>
          <div className="row p-1 border">
            <div className="col col-md-2">Quantity</div>
            <div className="col col-md-4">
              <InputText
                type="text"
                keyfilter="pint"
                value={this.state.qty}
                onChange={e => this.setState({ qty: e.target.value })}
                style={{ width: "300px" }}
                className="p-error"
              />
            </div>
          </div>
          <div className="row p-1 border">
            <button
              onClick={this.onAddClick}
              className="btn btn-primary btn-md mr-2"
            >
              Add Stock
            </button>
          </div>
          <Growl ref={el => (this.growl = el)} />
          <Messages ref={el => (this.messages = el)} />
        </div>
      </div>
    );
  }

  onNameSelect = e => {
    let results = this.state.medList.filter(t => {
      return t.name.toLowerCase() === e.value.toLowerCase();
    })[0];

    axios
      .get(
        (process.env.NODE_ENV !== "development"
          ? appConst.API_URL_PROD
          : appConst.API_URL_DEV) +
        "/medicine/getStock/" +
        results.mno
      )
      .then(response => {
        this.setState({
          mainStock: response.data.stock.main
        });
      })
      .catch(function (error) {
        console.log(error);
      });

    this.setState({ mno: results.mno, name: results.name });
  };

  onNameChange = e => {
    this.setState({
      name: e.value,
      mainStock: 0,
      qty: 0
    });
  };

  onAddClick = async e => {
    e.preventDefault();

    if (this.state.expdate === "") {
      this.messages.show({
        severity: "error",
        summary: "Error !!",
        detail: "Enter Expiry Date !!"
      });
    } else {
      if (this.state.qty > 0) {

        const obj = {
          mno: this.state.mno,
          qty: this.state.qty,
          name: this.state.name
        };

        axios
          .post(
            (process.env.NODE_ENV !== "development"
              ? appConst.API_URL_PROD
              : appConst.API_URL_DEV) +
            "/medicine/inbound",
            obj
          )
          .then(res => {
            this.ClearData();
            this.growl.show({
              severity: "success",
              summary: "Success",
              detail: "Medicine Added !!!"
            });
            this.LoadNames();
          })
          .catch(error => {
            this.growl.show({
              severity: "error",
              summary: "Error",
              detail: "Something went wrong !!"
            });
          });
      } else {
        this.messages.show({
          severity: "error",
          summary: "Error !!",
          detail: "Invalid Quantity !!"
        });
      }
    }
  };

  ClearData() {
    this.setState({
      name: "",
      mainStock: 0,
      qty: 0
    });
  }

}

export default Inbound;
